import React, {useState} from "react";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import {Box, CircularProgress} from "@mui/material";
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component"
import ContainerStatusListDropdownComponent from "../common/container-status-list-dropdown.component";
import useContainer from "../hooks/useContainer";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import {useLocation} from "react-router-dom";
import CustomTextField from "../../../core/components/ui/CustomTextfield";


const UpdateStatusDialog = (props) => {
    const {open, setOpen, selectedContainer} = props;

    const location = useLocation();
    
    const {isUpdatingContainerStatus, isFetchingContainerStatusList, containerStatusList, 
        getContainerStatusList, updateContainerStatus
    } = useContainer();

    const [selectedStatus, setSelectedStatus] = useState(selectedContainer?.status);
    const [reasonInput, setReasonInput] = useState(selectedContainer?.purpose || "");

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const storedOrgIdFromRBACForBusiness = rbacStorage?.state?.currentProfile?.orgId || null;
    const orgIdFromUrlForPortEmployee = new URLSearchParams(location.search).get("org_uid");


    const handleStatusChange = (value) => {
        setSelectedStatus(value);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleTextfieldChange = (e) => {
        setReasonInput(e.target.value);
    }

    const handleUpdateStatus = () => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;
        const reasonForStatus = (selectedStatus === "Decommissioned") ? reasonInput : " ";

        if (organizationId) {
            const parameters = {
                containerUID: selectedContainer?.container_uid,
                status: selectedStatus,
                purpose: reasonForStatus,
                orgUID: organizationId
            };

            updateContainerStatus(parameters);

        } else {
            const parameters = {
                containerUID: selectedContainer?.container_uid,
                status: selectedStatus,
                purpose: reasonForStatus
            };

            updateContainerStatus(parameters);
        }
    }

    const actions = [
        {
            label: "Cancel",
            onClick: (e) => setOpen(false),
            variant: "outlined",
            customStyles: {
                opacity: 1, mr: 1
            }
        },
        {
            label: "Update",
            onClick: (e) => (!selectedStatus || isUpdatingContainerStatus || (selectedStatus === "Decommissioned" && !reasonInput.trim())) ? null : handleUpdateStatus(e),
            customStyles: {
                opacity: (!selectedStatus || isUpdatingContainerStatus || (selectedStatus === "Decommissioned" && !reasonInput.trim())) ? "55%" : "100%",
                cursor: (!selectedStatus || isUpdatingContainerStatus || (selectedStatus === "Decommissioned" && !reasonInput.trim())) ? "not-allowed !important" : "pointer",
                visibility: (isUpdatingContainerStatus) ? "hidden" : "visible",
            },
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={(isUpdatingContainerStatus) ? null : handleClose}
                title="Update Status"
                subtitle={"Manage container status in real-time"}
                hasDividers={true}
                content={
                    <Box>
                        {(isUpdatingContainerStatus) ? 
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent 
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Updating container status..."}
                                />
                            </Box>
                        : 
                            <>
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Status"}
                                    customStyles={{
                                        mb: (selectedStatus) ? 2 : 1
                                    }}
                                />

                                <ContainerStatusListDropdownComponent 
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                    fullWidth={true}
                                    size={"medium"}
                                    isFetchingContainerStatusList={isFetchingContainerStatusList}
                                    containerStatusList={containerStatusList}
                                    getContainerStatusList={getContainerStatusList}
                                /> <br/>

                                {(selectedStatus === "Decommissioned") &&
                                    <>
                                        <CustomTypography 
                                            variant="subtitle2"
                                            text={"Reason"}
                                            customStyles={{}}
                                        />
                                        <CustomTextField 
                                            placeholder={"Enter reason"}
                                            variant={"outlined"}
                                            value={reasonInput}
                                            onChange={(e) => handleTextfieldChange(e)}
                                            fullWidth={true}
                                            multiline={false}
                                            hiddenLabel
                                            readOnly={isUpdatingContainerStatus}
                                        />    
                                    </>
                                }
                            </>
                        }
                    </Box>
                }
                actions={!isUpdatingContainerStatus && actions}
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
        </>
    )
}

export default UpdateStatusDialog
